import { render, staticRenderFns } from "./AlertTable.vue?vue&type=template&id=f57e4508&scoped=true&"
import script from "./AlertTable.vue?vue&type=script&lang=js&"
export * from "./AlertTable.vue?vue&type=script&lang=js&"
import style0 from "./AlertTable.vue?vue&type=style&index=0&id=f57e4508&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57e4508",
  null
  
)

export default component.exports